import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { products } from '../utils/products';
import { Button } from '../components/ui/Button';
import { useCart } from '../context/CartContext';
import { Check, ArrowLeft, ShieldCheck, Truck, RotateCcw } from 'lucide-react';
export function ProductPage() {
  const {
    id
  } = useParams();
  const {
    addToCart
  } = useCart();
  const product = products.find(p => p.id === id);
  if (!product) {
    return <div className="min-h-screen flex items-center justify-center flex-col gap-4" data-id="element-352">
        <h1 className="text-2xl font-bold" data-id="element-353">Product not found</h1>
        <Link to="/" data-id="element-354">
          <Button data-id="element-355">Back to Home</Button>
        </Link>
      </div>;
  }
  return <div className="bg-white min-h-screen py-12" data-id="element-356">
      <div className="container mx-auto px-4" data-id="element-357">
        <Link to="/#products" className="inline-flex items-center text-gray-600 hover:text-[#E63946] mb-8 transition-colors" data-id="element-358">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-359" /> Back to Products
        </Link>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-360">
          {/* Image */}
          <div className="bg-gray-50 rounded-lg p-8 flex items-center justify-center" data-id="element-361">
            <img src={product.image} alt={product.name} className="w-full max-h-[500px] object-contain" data-id="element-362" />
          </div>

          {/* Details */}
          <div data-id="element-363">
            <span className="text-[#FDB913] font-bold uppercase tracking-wider text-sm" data-id="element-364">
              {product.category === 'unit' ? 'Professional Series' : product.category === 'kit' ? 'DIY Series' : 'Parts & Accessories'}
            </span>
            <h1 className="text-3xl md:text-4xl font-black text-[#1a1a1a] mt-2 mb-4" data-id="element-365">
              {product.name}
            </h1>
            <div className="text-3xl font-bold text-[#E63946] mb-6" data-id="element-366">
              ${product.price.toLocaleString()}
            </div>

            <p className="text-gray-600 text-lg leading-relaxed mb-8" data-id="element-367">
              {product.description}
            </p>

            <div className="mb-8" data-id="element-368">
              <h3 className="font-bold text-[#1a1a1a] mb-4" data-id="element-369">Key Features:</h3>
              <ul className="space-y-3" data-id="element-370">
                {product.features.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-371">
                    <Check className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-372" />
                    <span className="text-gray-700" data-id="element-373">{feature}</span>
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-374">
              <Button onClick={() => addToCart(product)} size="lg" className="flex-1" data-id="element-375">
                Add to Cart
              </Button>
            </div>

            <div className="grid grid-cols-3 gap-4 border-t border-gray-100 pt-8" data-id="element-376">
              <div className="flex flex-col items-center text-center gap-2" data-id="element-377">
                <ShieldCheck className="w-6 h-6 text-gray-400" data-id="element-378" />
                <span className="text-xs text-gray-500 font-medium" data-id="element-379">
                  1 Year Warranty
                </span>
              </div>
              <div className="flex flex-col items-center text-center gap-2" data-id="element-380">
                <Truck className="w-6 h-6 text-gray-400" data-id="element-381" />
                <span className="text-xs text-gray-500 font-medium" data-id="element-382">
                  Fast Shipping
                </span>
              </div>
              <div className="flex flex-col items-center text-center gap-2" data-id="element-383">
                <RotateCcw className="w-6 h-6 text-gray-400" data-id="element-384" />
                <span className="text-xs text-gray-500 font-medium" data-id="element-385">
                  30-Day Returns
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}